"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logDeprecatedWarnings = exports.BASE_URL = void 0;
const tslib_1 = require("tslib");
const has_1 = tslib_1.__importDefault(require("lodash/fp/has"));
exports.BASE_URL = 'https://uikit.developers.rio.cloud/';
// Logs deprecation warnings to console if prop is used.
// use this function in the render method of a component.
const logDeprecatedWarnings = (deprecatedProps, props, componentName, removeVersion, additionalText) => {
    deprecatedProps.forEach(deprecatedProp => {
        // Check whether the deprecated prop is used by checking the component props
        if ((0, has_1.default)(deprecatedProp.prop, props)) {
            console.warn([
                'RIO UIKIT: ',
                deprecatedProp.propCaption ? deprecatedProp.propCaption : 'Prop',
                ` "${deprecatedProp.prop}" is deprecated`,
                componentName ? ` for "${componentName}"` : '',
                removeVersion ? ` and will be removed in v${removeVersion}` : '',
                deprecatedProp.replacement ? `. Please use "${deprecatedProp.replacement}" instead` : '',
                deprecatedProp.url ? ` as documented in ${exports.BASE_URL}${deprecatedProp.url}. ` : '.',
                additionalText ? ` ${additionalText}` : '',
            ].join(''));
        }
    });
};
exports.logDeprecatedWarnings = logDeprecatedWarnings;
exports.default = exports.logDeprecatedWarnings;
